<template>
  <div>
    <InfoDialogBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :pageData="pageData"
      :recItems="recItems"
      :isFooter="true"
      :isTotalAmount="false"
      @editRemarks="editRemarks"
      :isEdit="isEdit"
    >
      <template #footer>
        <TotalAmount v-model="registerData.totalList" />
        <NormalButton
          :text="$t('common.input_fix')"
          color="white"
          class="pr-5"
          textColor="thinText--text"
          height="50px"
          width="130px"
          @click="inputedValue.dialog = false"
        />
        <NormalButton
          :text="$t('common.input_save')"
          height="50px"
          width="130px"
          :loading="isBtnLoading"
          @click="isEdit ? edit() : register()"
        />
        <DialogAlertSuccess
          v-model="completeDialog"
          :text="$t('common.common_register-complete')"
        />
      </template>
    </InfoDialogBase>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

import InfoDialogBase from './SalesInfoDialogBase'
import TotalAmount from '@/components/items/Designs/TotalAmount/TotalAmount'
import NormalButton from '@/components/items/Buttons/NormalButton'
import DialogAlertSuccess from '@/components/layouts/Dialogs/DialogAlert/DialogAlertSuccess'

import headers from '@/views/sales/History/headers'

export default {
  components: {
    InfoDialogBase,
    TotalAmount,
    NormalButton,
    DialogAlertSuccess
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    isEdit: { default: false },
    saleId: { default: undefined },
    registerData: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    recItems: {},
    pageData: [{}, {}, {}, {}, {}, {}],
    completeDialog: false,
    isBtnLoading: false,
    remarks: {
      private: '',
      client: ''
    },
    saleEditHistoryList: []
  }),
  created() {
    // this.init()
  },
  methods: {
    ...mapActions('Sale', ['registerSale', 'editSale', 'getSaleDetailFromApi']),
    ...mapActions('Common', ['setIsLoading']),

    async init() {
      if (this.inputedValue.dialog) {
        const productMovesTmp = this.registerData.product.data.map(
          (ele, index) => {
            return {
              productMoveId: index,
              price: ele.price,
              quantity: ele.count,
              currencyId: ele.currencyId,
              exportSubjectFlg: ele.exportSubjectFlg,
              product: ele
            }
          }
        )

        this.recItems = {
          productMoves: productMovesTmp,
          client: this.registerData.client,
          totalList: this.registerData.totalList
        }
      }

      this.pageData = [
        {
          title: 'payment.payment_customer-info',
          name: 'paymentInfo',
          items: [],
          itemKey: ''
        },
        {
          title: 'common.input_sale-details',
          name: 'paymentHistory',
          headers: headers.productListHeaders,
          items: [],
          footers: [],
          itemKey: Object.keys(this.recItems).length ? this.recItems.saleId : ''
        }
      ]
      if (!this.isEdit) {
        this.pageData.push({
          title: 'sale.sale_note',
          name: 'test1',
          items: [],
          itemKey: ''
        })
      } else {
        const saleDetailList = await this.getSaleDetailFromApi({
          saleIds: this.saleId
        })
        this.saleEditHistoryList = saleDetailList.data[0].saleEditHistoryList
      }
    },
    async register() {
      this.setIsLoading(true)
      this.isBtnLoading = true
      const isSuccess = await this.registerSale(this.request)
      if (isSuccess) {
        this.completeDialog = true
      }
      this.isBtnLoading = false
      this.setIsLoading(false)
    },
    async edit() {
      this.setIsLoading(true)
      this.isBtnLoading = true
      const params = this.request
      let beforeSaleEditHistoryId = null
      this.saleEditHistoryList.forEach((history) => {
        if (beforeSaleEditHistoryId === null) {
          beforeSaleEditHistoryId = history.saleEditHistoryId
        } else if (beforeSaleEditHistoryId < history.saleEditHistoryId) {
          beforeSaleEditHistoryId = history.saleEditHistoryId
        }
      })
      params.beforeSaleEditHistoryId = beforeSaleEditHistoryId
      const isSuccess = await this.editSale(params)
      if (isSuccess) {
        this.completeDialog = true
      }
      this.isBtnLoading = false
      this.setIsLoading(false)
    },
    editRemarks(...args) {
      const [remarks] = args
      this.remarks = {
        private: remarks.private,
        client: remarks.client
      }
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    request() {
      return {
        id: this.saleId,
        clientData: this.registerData.client,
        registerProductList: this.registerData.product.data,
        totalList: this.registerData.totalList,
        privateRemarks: this.remarks.private,
        clientRemarks: this.remarks.client
      }
    }
  },
  watch: {
    inputedValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.dialog) this.init()
      }
    },
    completeDialog: function (newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$router.push({ name: 'sales.history' })
        this.inputedValue.dialog = false
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
